export const colorMap = {
  'Black': 'black',
  'Black Titanium': 'black',
  'Blue': 'blue',
  'Blue Titanium': 'blue',
  'Deep Purple': 'purple',
  'Gold': 'gold',
  'Graphite': 'gray',
  'Green': 'green',
  'Midnight': 'midnightblue',
  'Natural Titanium': 'gray',
  'Pink': 'pink',
  'Purple': 'mediumpurple',
  'Red': 'red',
  'Silver': 'silver',
  'Space Black': 'black',
  'Space Gray': 'gray',
  'Starlight': 'silver',
  'White': 'white',
  'White Titanium': 'white',
  'Yellow': 'yellow',
};
